import { useCurrentUser, useEnhancedLipsyncEnabled, useSettings } from '@/entities/user/currentUser';

import { CONTENT } from '../lib/limitedFeatures';
import { getLipSyncContentEnhanced } from '../lib/limitedFeatures/lipSync';
import { LimitedFeature, PLAN_CATEGORIES, PlanCategoriesKeys } from '../lib/types';
import { useProducts } from './useProducts';

export const useUpgradePlanModalContent = (limitedFeature: LimitedFeature, plan?: PlanCategoriesKeys) => {
  const { products } = useProducts(true);

  const { data: user } = useCurrentUser();
  const isEnhancedLipsyncEnabled = useEnhancedLipsyncEnabled();
  const {
    scope_settings: { available_features: availableFeatures },
  } = useSettings();

  const userPlanCategory =
    plan ?? products?.plan.find((p) => p.id === user?.subscription?.plan.product_id)?.category ?? 'trial';

  const planCategory = PLAN_CATEGORIES[userPlanCategory];

  const featureContent =
    limitedFeature === 'lipSync' && isEnhancedLipsyncEnabled
      ? getLipSyncContentEnhanced(availableFeatures.lipsync_v2?.metadata?.minutes_cost_multiplier)
      : CONTENT[limitedFeature];

  return {
    content: featureContent[planCategory] ?? featureContent['trial'],
    planCategory,
  };
};
